import { ComponentPropsWithoutRef } from "react";

export const UnsortedIcon = ({ ...props }: ComponentPropsWithoutRef<"svg">) => {
  return (
    <svg {...props} viewBox="0 0 14 14">
      <path d="M5.645 3.613a.67.67 0 0 1-.479-.199l-1.779-1.78-1.78 1.78a.681.681 0 0 1-.957 0 .681.681 0 0 1 0-.957L2.908.199a.681.681 0 0 1 .958 0l2.258 2.258a.681.681 0 0 1 0 .957.67.67 0 0 1-.479.199Z" />
      <path d="M3.387 14a.682.682 0 0 1-.677-.677V.677c0-.37.307-.677.677-.677.37 0 .678.307.678.677v12.646c0 .37-.308.677-.678.677ZM10.613 14a.67.67 0 0 1-.479-.199l-2.258-2.258a.681.681 0 0 1 0-.957.682.682 0 0 1 .958 0l1.779 1.78 1.78-1.78a.682.682 0 0 1 .957 0 .682.682 0 0 1 0 .957l-2.258 2.258a.67.67 0 0 1-.48.199Z" />
      <path d="M10.613 14a.682.682 0 0 1-.677-.677V.677c0-.37.307-.677.677-.677.37 0 .677.307.677.677v12.646c0 .37-.307.677-.677.677Z" />
    </svg>
  );
};
